import { observable, action, runInAction} from "mobx";
import { DateTime } from "luxon";

import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { BetsReport } from "@api-types/bet-slip/BetsReport";
import { RootStore } from "@state/stores/types.js";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { RequestContextType } from "@utils/api-config/RequestContext";
import ReportInsightsApiService from "@api-services/reports/ReportInsightsApiService";

export class ReportsStore {
	rootStore: RootStore;
	myBetsStore: MyBetsStore;

	constructor(rootStore: RootStore, myBetsStore: MyBetsStore) {
		this.rootStore = rootStore;
		this.myBetsStore = myBetsStore;
	}

	//#region observables

	@observable betsReport: BetsReport[] | null = null;
	@observable isDetailsOpen = false;

	@observable from: string | null = null;
	@observable to: string | null = null;

	//#endregion observables

	//#region actions

	@action.bound
	async fetchReports(
		filter: { bettingAccountTypeAbrv: string; from: string; to: string },
		walletId?: string
	) {
		const betsReport = await ReportInsightsApiService.getMyBetsReport(
			filter.from,
			filter.to,
			filter.bettingAccountTypeAbrv,
			createApiRequestOptions(RequestContextType.Wallet, walletId)
		);

		const from = DateTime.fromISO(filter.from).toLocaleString(
			DateTime.DATE_SHORT
		);
		const to = DateTime.fromISO(filter.to).toLocaleString(
			DateTime.DATE_SHORT
		);

		runInAction(() => {
			this.from = from;
			this.to = to;
			this.betsReport = betsReport?.result;
		});
	}

	@action.bound
	openDetails() {
		this.isDetailsOpen = true;
	}

	@action.bound
	closeDetails() {
		this.isDetailsOpen = false;
	}

	//#endregion actions

	//#region disposers

	@action.bound
	onDispose() {
		this.betsReport = null;
		this.closeDetails();
	}

	//#endregion disposers
}
